/**
 * Fizetési-mód build-konfiguráció (demo-trust batch, party rank-4/b).
 *
 * A MyPOS bankkártya-ág a `VITE_MYPOS_ENABLED` env-flaghez kötött (a backend
 * `MYPOS_ENABLED` tükre). Amíg false (demo/UAT, MyPOS-sandbox nélkül), a CARD
 * fizetési-tile ELREJTVE marad (nem disabled) — ne mutassunk olyan opciót ami
 * graceful-FAILED a backenden. Default false: csak explicit opt-innal jelenik meg.
 */
export function isMyposEnabled(): boolean {
  return import.meta.env.VITE_MYPOS_ENABLED === 'true';
}
